import { MenuItem } from '@adaptiva/core/menus';
import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable, of, switchMap } from 'rxjs';
import { LlmConversationNode } from '../classes';
import { LlmHistoryService } from '../services';
import { BaseLlmNodeMenuController } from './base-llm-node-menu-controller';

@Injectable()
export class LlmHistoryMenuController extends BaseLlmNodeMenuController {

	public readonly deleteNodeMenuName: string = 'Delete';

	protected readonly history: LlmHistoryService = inject(LlmHistoryService);

	public generate(_node: LlmConversationNode): Observable<MenuItem<LlmConversationNode>[]> {
		const _menuItems: MenuItem[] = [
			this.getOpenInChatMenuItem(_node),
			this.getDeleteMenuItem(_node),
		];

		if (_node.parent)
			_menuItems.push(this.getCreateForkMenuItem(_node));

		return of(_menuItems);
	}

	public getDeleteMenuItem(_node: LlmConversationNode): MenuItem<LlmConversationNode> {
		const _itemId: string = this.hashItem(this.deleteNodeMenuName, _node);
		const _item: MenuItem<LlmConversationNode> = this.getItem(_itemId, _node) || this.createItem({
			id: _itemId,
			name: this.deleteNodeMenuName,
			data: _node,
			onSelect: this.delete.bind(this),
		});

		return _item;
	}

	protected delete(_item: MenuItem<LlmConversationNode>): void {
		this.overlays.confirm(
			'Are you sure?',
			`Deleting this node will also delete any downstream nodes the "${_item.data.forkName}" fork. ` +
			'This action cannot be undone. Delete the node?',
		).pipe(
			switchMap((_isConfirmed: boolean) => {
				if (!_isConfirmed)
					return EMPTY;

				return this.history.deleteNode(_item.data);
			})
		).subscribe({
			next: (): void => {
				this.snackbars.display('Successfully deleted node');
			},
			error: (e: Error): void => {
				this.errorHandler.defaultErrorHandler(e, 'LlmHistoryMenuController.delete');
			}
		});
	}

}
